{
  "pageTitle": "News",
  "title1": "The Latest About",
  "title2": "Manara School",
  "subtitle": "Know more about Manara students, staff and alumni achievements, inside and outside the classroom, and all around the world.",
  "loadMore": "Load More News",
  "articlesError": "Failed to get articles data"
}
